"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrentAge = CurrentAge;
exports.LifeExpectancy = LifeExpectancy;
exports.LongTermExpectation = LongTermExpectation;
exports.LostJob = LostJob;
exports.Performance3MonthGoal = Performance3MonthGoal;
exports.Performance3YearGoal = Performance3YearGoal;
exports.PortfolioGoal = PortfolioGoal;
exports.PortfolioPercentage = PortfolioPercentage;
exports.RetirementAge = RetirementAge;
exports.RiskTolerance = RiskTolerance;
exports.WithdrawPlan = WithdrawPlan;
var _react = _interopRequireDefault(require("react"));
var _DropdownForNatLangForm = require("../Wizard/DropdownForNatLangForm");
var _TextInputForNatLangForm = require("../Wizard/TextInputForNatLangForm");
var _InvestorProfileWizardCalc = require("./InvestorProfileWizardCalc.config");
var _formikMiddleware = _interopRequireDefault(require("../../middleware/formikMiddleware"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Dropdown inputs start here
function WithdrawPlan(_ref) {
  var {
    values,
    setFieldValue
  } = _ref;
  var fieldName = 'withdrawPlan';
  var preText = 'I ';
  var postText = ' to withdraw my money in three years or less';
  return /*#__PURE__*/_react.default.createElement(_DropdownForNatLangForm.DropdownForNatLangForm, {
    values: values,
    dropdownArray: _InvestorProfileWizardCalc.dropdownOptions.withdrawPlan,
    fieldName: fieldName,
    preText: preText,
    setFieldValue: setFieldValue,
    postText: postText,
    calcName: _InvestorProfileWizardCalc.calcName
  });
}
function RiskTolerance(_ref2) {
  var {
    values,
    setFieldValue
  } = _ref2;
  var fieldName = 'riskTolerance';
  var preText = ' and ';
  return /*#__PURE__*/_react.default.createElement(_DropdownForNatLangForm.DropdownForNatLangForm, {
    values: values,
    dropdownArray: _InvestorProfileWizardCalc.dropdownOptions.riskTolerance,
    fieldName: fieldName,
    preText: preText,
    setFieldValue: setFieldValue,
    className: "endOfSentence",
    calcName: _InvestorProfileWizardCalc.calcName
  });
}
function CurrentAge(_ref3) {
  var {
    errors,
    touched,
    values
  } = _ref3;
  var fieldName = 'currentAge';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '3';
  var placeholder = '00';
  var htmlSize = '3';
  var preText = ' I am ';
  var postText = ' years old,';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_InvestorProfileWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForNatLangForm.TextInputForNatLangForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    htmlSize: htmlSize,
    preText: preText,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    postText: postText
  });
}
function RetirementAge(_ref4) {
  var {
    values,
    setFieldValue
  } = _ref4;
  var fieldName = 'retirementAge';
  var preText = ' and expect to retire at ';
  var postText = ' years old.';
  return /*#__PURE__*/_react.default.createElement(_DropdownForNatLangForm.DropdownForNatLangForm, {
    values: values,
    dropdownArray: _InvestorProfileWizardCalc.dropdownOptions.retirementAge,
    fieldName: fieldName,
    preText: preText,
    setFieldValue: setFieldValue,
    postText: postText,
    calcName: _InvestorProfileWizardCalc.calcName
  });
}
function LifeExpectancy(_ref5) {
  var {
    errors,
    touched,
    values
  } = _ref5;
  var fieldName = 'lifeExpectancy';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '3';
  var placeholder = '00';
  var htmlSize = '3';
  var preText = ' I need retirement income until I am ';
  var postText = ' years old.';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_InvestorProfileWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForNatLangForm.TextInputForNatLangForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    htmlSize: htmlSize,
    preText: preText,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    postText: postText
  });
}
function PortfolioGoal(_ref6) {
  var {
    values,
    setFieldValue
  } = _ref6;
  var fieldName = 'portfolioGoal';
  var preText = 'For this portfolio, my goal is to  ';
  return /*#__PURE__*/_react.default.createElement(_DropdownForNatLangForm.DropdownForNatLangForm, {
    values: values,
    dropdownArray: _InvestorProfileWizardCalc.dropdownOptions.portfolioGoal,
    fieldName: fieldName,
    preText: preText,
    setFieldValue: setFieldValue,
    className: "endOfSentence",
    calcName: _InvestorProfileWizardCalc.calcName
  });
}
function LongTermExpectation(_ref7) {
  var {
    values,
    setFieldValue
  } = _ref7;
  var fieldName = 'longTermExpectation';
  var preText = ' Over time, I would expect to ';
  return /*#__PURE__*/_react.default.createElement(_DropdownForNatLangForm.DropdownForNatLangForm, {
    values: values,
    dropdownArray: _InvestorProfileWizardCalc.dropdownOptions.longTermExpectation,
    fieldName: fieldName,
    preText: preText,
    setFieldValue: setFieldValue,
    className: "endOfSentence",
    calcName: _InvestorProfileWizardCalc.calcName
  });
}
function Performance3YearGoal(_ref8) {
  var {
    values,
    setFieldValue
  } = _ref8;
  var fieldName = 'performance3YearGoal';
  var preText = ' In the next three years, I ';
  return /*#__PURE__*/_react.default.createElement(_DropdownForNatLangForm.DropdownForNatLangForm, {
    values: values,
    dropdownArray: _InvestorProfileWizardCalc.dropdownOptions.performance3YearGoal,
    fieldName: fieldName,
    preText: preText,
    setFieldValue: setFieldValue,
    className: "endOfSentence",
    calcName: _InvestorProfileWizardCalc.calcName
  });
}
function Performance3MonthGoal(_ref9) {
  var {
    values,
    setFieldValue
  } = _ref9;
  var fieldName = 'performance3MonthGoal';
  var preText = 'Over the next three months, I would ';
  return /*#__PURE__*/_react.default.createElement(_DropdownForNatLangForm.DropdownForNatLangForm, {
    values: values,
    dropdownArray: _InvestorProfileWizardCalc.dropdownOptions.performance3MonthGoal,
    fieldName: fieldName,
    preText: preText,
    setFieldValue: setFieldValue,
    className: "endOfSentence",
    calcName: _InvestorProfileWizardCalc.calcName
  });
}
function LostJob(_ref10) {
  var {
    values,
    setFieldValue
  } = _ref10;
  var fieldName = 'lostJob';
  var preText = ' If I lost my job tomorrow, I would have enough cash on hand to last ';
  return /*#__PURE__*/_react.default.createElement(_DropdownForNatLangForm.DropdownForNatLangForm, {
    values: values,
    dropdownArray: _InvestorProfileWizardCalc.dropdownOptions.lostJob,
    fieldName: fieldName,
    preText: preText,
    setFieldValue: setFieldValue,
    className: "endOfSentence",
    calcName: _InvestorProfileWizardCalc.calcName
  });
}
function PortfolioPercentage(_ref11) {
  var {
    values,
    setFieldValue
  } = _ref11;
  var fieldName = 'portfolioPercentage';
  var preText = ' Upon retirement, my investment portfolio will represent ';
  var postText = ' of my retirement income. ';
  return /*#__PURE__*/_react.default.createElement(_DropdownForNatLangForm.DropdownForNatLangForm, {
    values: values,
    dropdownArray: _InvestorProfileWizardCalc.dropdownOptions.portfolioPercentage,
    fieldName: fieldName,
    preText: preText,
    setFieldValue: setFieldValue,
    postText: postText,
    calcName: _InvestorProfileWizardCalc.calcName
  });
}